
import React, { Component } from 'react';
import services from '../../../../services';
import $ from 'jquery'
import TlkTable from '../../../../components/tlelrik/table/tlkTable';
import RightPopModalForm from '../../../../components/common/RightPopModalForm';
import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import ParcelVirsion from '../../../../components/Parcel-Right-panel/ParcelVirsion';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { insertItem, getItems3, updateItem, deleteItem, deleteAll } from "./services3";
import { MyCommandCell } from "./MyCommandCell3"
import { NumericCell } from '../NumericText';
import { FormatMoney } from '../FormatMoney';
import DropDownCellTipoVasilha from '../myDropDownCellTipoVasilha';
import DropDownCellNVasilha from '../myDropDownCellNVasilha';
import DropDownCellCapacidades from '../myDropDownCellCapacidades';
import DropDownCellProduto from '../myDropDownCellProduto';
import SelectCellEtiquetas from '../mySelectCellEtiquetas';
import SelectCellSelos from '../mySelectCellSelos';
import SelectCellSelosGarantia from '../mySelectCellSelosGarantia';
import Swal from 'sweetalert2';
import SelectCellEtiquetasSelagem from '../mySelectCellEtiquetasSelagem';
import SelectCellSelosSelagem from '../mySelectCellSelosSelagem';

var ThisSetState = null;
var arrayData = []
var arrayDataOnEdit = []
var ValueTipoVasilhaSelected = null;

var DropDownDisableValue = true;
var indexEntrada = 0
var idDropDownSelected = null;
var DropDownDisableArray = [];
var idDropDownDisableArray = 0;
var ThisDropDownDisable = null;

var ThisSetStateCreated = false;
const GridElement = null;


const queryString = require('query-string');
var moment = require('moment')
const dateFormat = "DD-MM-YYYY";
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
let today = new Date();
let current_date = moment(today).format(dateFormat);
today.setDate(today.getDate() - 7);
let LastWeek = moment(today).format(dateFormat);

today = new Date();
today.setDate(today.getDate() - 14);
let Last2Week = moment(LastWeek).format(dateFormat);

today = new Date();
today.setMonth(today.getMonth() - 1);
let Pastmonthdate = moment(today).format(dateFormat);
const editField = "inEdit"; 
let parsed = queryString.parse(window.location.search);
var idAutoQuery = parsed.idAuto
var DesselagemQuery = parsed.Desselagem
var idAutoe;

let tablesjson = {
    "LinhasFatura": {
        columnkeyMap: {
            "matricula" : "Matrícula",
            "documentoTransporte" : "Doc. Transporte",
            "certificadoProcedencia" : "Cert. Procedência",
            "rcdo" : "RCDO",
            "volumeViatura": "Volume",
            "selosSegurancaSelagemViatura" : "Selos Segurança",
            "etiquetasSegurancaViatura" : "Etiquetas Segurança",
            "sinetesViatura": "Sinetes",
        },
        actionbuttons: { Delete: "apagar" },
        listApilink: "/Fiscalizacao/GetAutoDetalhe",
        requestMethod: "get",
        notAction: false,
        Filters: {"idAuto" : parseInt(idAutoQuery)},
    },
}

class DropDownCellFiscalizacao3 extends React.Component {

    localizedData = [
      { text: 'Escala', value: 1 },
      { text: 'Estimativa', value: 2 },
      { text: 'Cálculo', value: 3 }
    ];
  
    handleChange = (e) => {
      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e != null ? e.syntheticEvent : null,
        value: e != null ? e.target != null ? e.target.value : null : null
      });
    }
    
    static disablEnableDroDown = (disable) => {
        DropDownDisableValue = disable;
        ThisDropDownDisable.handleChange();

    }

    render() {
        ThisDropDownDisable = this;
        
        const dataValue = this.props.dataItem[this.props.field];
        
        if (!this.props.dataItem.inEdit) {
            return (
            <td>
                {(dataValue === null || dataValue === undefined) ? '' : this.props.dataItem[this.props.field].text}
            </td>
            );
        }

        return (
            <td>

                <DropDownList
                    popupSettings={{
                        width: 'max-content',
                    }}
                    disabled={DropDownDisableValue}
                    onChange={this.handleChange}
                    value={this.localizedData.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
                    data={this.localizedData}
                    textField="text"
                />

            </td>
        );
        
    }
}

class DropDownCellMotivoDispensa3 extends React.Component {

    localizedData = [
      { text: 'Início imediato do despejo', value: 1 },
      { text: 'Nº reduzido de garrafas devolvidas', value: 2 },
      { text: 'Colheita de amostras há menos de 6 meses', value: 3 }
    ];
  
    handleChange = (e) => {
      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e != null ? e.syntheticEvent : null,
        value: e != null ? e.target != null ? e.target.value : null : null
      });
    }

    render() {
        ThisDropDownDisable = this;
        
        const dataValue = this.props.dataItem[this.props.field];
        
        if (!this.props.dataItem.inEdit) {
            return (
            <td>
                {(dataValue === null || dataValue === undefined) ? '' : this.props.dataItem[this.props.field].text}
            </td>
            );
        }

        return (
            <td>

                <DropDownList
                    popupSettings={{
                        width: 'max-content',
                    }}
                    onChange={this.handleChange}
                    value={this.localizedData.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
                    data={this.localizedData}
                    textField="text"
                />

            </td>
        );
        
    }
}

class ClassGrid3 extends Component {
    /* Primeiro passo na acomodação da classe */
    

    constructor(props) {
        super(props);
        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            findnonDocumentedRow: 0,
            error : null,
            filtroEntidade: null,
            artigo: [],
            Auto:null,
            Columns:[],
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {

        console.log(this.props.columnList);

       

        ThisSetState = this;

        this.defaultState();

        (async () => {
            this.setState({
                data: await getItems3(),
                Columns: this.props.columnList
            }); 

            const datapagamento = {}
                const TipoPagamento = await services.apiCall.requestApi(
                   "/Receita/GetTipoPagamento",
                   datapagamento,
                   "get"
                );
                console.log(TipoPagamento)
                this.setState({
                    artigo: TipoPagamento               
                })

                console.log("QUERO SABER", this.state.artigo)
                console.log("QUERO SABER 2" ,tablesjson)
        })();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (preProp) => {
        if (preProp.date !== this.props.date || preProp.tableName !== this.props.tableName) {
            console.log("update",this.props,preProp)
            this.defaultState();
        }
    }


    /* Para obter filtros para a API */
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        return Request.Filters ;
    }

    static getGridDetails(){
        return idAutoe 
    }
    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (id) => {
        let link = this.state.linkData.deleteAPILink;
        let res = await services.apiCall.requestApi(link + "/" + id, {}, 'post')
        if (res) {
            this.defaultState();
        }
    }

    /* Carregar estado de página padrão  */

    defaultState = () => {
        let linkData = { ...tablesjson }
        linkData = tablesjson.LinhasFatura;
        // if(DesselagemQuery == "true"){
        //     this.setState({
        //         linkData: linkData,
        //         findnonDocumentedRow: 0,
        //         tlkState: {
        //             take: 100,
        //             skip: 0,
        //             group: [],
        //             exporting: false,
        //         }
        //     }, () => this.getListData())
        // }
        
    }

    /*Para obter dados para a tabela usando apis */

    deleteFunc = async (_row) => {
        var data = [];
        var datax = { ...this.state.data };
        
        const propertyNames = Object.values(datax);
        console.log(propertyNames)

        for (let index = 0; index < propertyNames.length; index++) {
            var datay = propertyNames[index].idAutoDetalhe;

            if(datay != _row.idAutoDetalhe){
               data.push(datax[index])
            }
        console.log("--------> matches" , data)
        this.setState({
           data:data
        }, () => this.getListDataDelete())
        }
}
getListDataDelete = async () => {
           
    if (!this.state.linkData) return
   
    if (this.state.linkData.singleEntity) {
        this.setState({
            totalcount: 0,
            telkikTable: null,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
        })
    }
  
 
    let columnkeyMap = this.state.linkData.columnkeyMap;
    console.log("OUTRO OBJETO" , Request)
    console.log(this.state.data , "-----> this.state.data" )
    if(this.state.data != undefined){
        var res = this.state.data
        //temRequest = false
        var invoicecode = [];
        let findnonDocumentedRow = 0;
     
        if (res && res.length > 0) {
            res.map((_row, index) => {
                if (_row.invoiceHistory && _row.invoiceHistory.length > 0) {
                    
                    _row.invoiceHistory.map((_r, i) => {
                        invoicecode = [];
                        if (_r.file_Link && _r.invoiceType) {
                            invoicecode = _r.invoiceType.split("-");
                            if (invoicecode[0] === "IVF" || invoicecode[0] === "IVP" || invoicecode[0] === "API") {
                                _row.document_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                            } else {
                                _row.invoice_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                            }
                        } else {
                            findnonDocumentedRow = findnonDocumentedRow + 1;
                        }
                    })
                } else {
                    findnonDocumentedRow = findnonDocumentedRow + 1;
                    console.log("AGORA" , _row)
                }
                Object.keys(columnkeyMap).map(function (key) {
                    if (key === "selosSegurancaSelagemViatura") {
                        for (let index = 0; index < _row.selosSegurancaSelagemViatura.length; index++) {
                            var selo = _row.selosSegurancaSelagemViatura[index].selo
                            if(index == 0){
                                var sequencia = selo
                            }else{
                                var sequencia = sequencia + "," + selo 
                            }
                            _row[columnkeyMap[key]] = sequencia
                        }
                    } else if (key === "etiquetasSegurancaViatura") {
                        for (let index = 0; index < _row.etiquetasSegurancaViatura.length; index++) {
                            var selo = _row.etiquetasSegurancaViatura[index].etiqueta
                            if(index == 0){
                                var sequencia = selo
                            }else{
                                var sequencia = sequencia + "," + selo 
                            }
                            _row[columnkeyMap[key]] = sequencia
                        }
                    }else
                        _row[columnkeyMap[key]] = _row[key]
                })
                if (_row.document_type === "Invoice") {
                    _row.document_type = "Movements"
                } else if (_row.document_type === "Credit") {
                    _row.document_type = "Crédito"
                }
            });
            console.log("Akash","1",res);
            idAutoe = res
            this.setState({
                data: res,
                filterData: res,
                totalcount: res.length,
                findnonDocumentedRow
            }, () =>{
                console.log("Akash","2");
                this.createTabel()
            });
        }else{
            this.setState({
                data: res,
                filterData: res,
                totalcount:0
            },()=>{
                this.createTabel()
            })
        }
    }
    
    
   

}
    /*Para obter dados para a tabela usando apis */

    getListData = async () => {
        try {
            if (!this.state.linkData) return
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                })
            }
            if (this.state.linkData.singleEntity && (!Request.Filters.entity_id && !Request.Filters.invoice_id)) return
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            console.log("OUTRO OBJETO" , Request)
            let res = await services.apiCall.requestApi(link, Request, method);
            var invoicecode = [];
            let findnonDocumentedRow = 0;
            if(DesselagemQuery ==  "true"){
                if (res != undefined){
                    res = res.autoGridViatura
                }
                
            }
            
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    if (_row.invoiceHistory && _row.invoiceHistory.length > 0) {
                        
                        _row.invoiceHistory.map((_r, i) => {
                            invoicecode = [];
                            if (_r.file_Link && _r.invoiceType) {
                                invoicecode = _r.invoiceType.split("-");
                                if (invoicecode[0] === "IVF" || invoicecode[0] === "IVP" || invoicecode[0] === "API") {
                                    _row.document_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                                } else {
                                    _row.invoice_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                                }
                            } else {
                                findnonDocumentedRow = findnonDocumentedRow + 1;
                            }
                        })
                    } else {
                        findnonDocumentedRow = findnonDocumentedRow + 1;
                        console.log("AGORA" , _row)
                    }
                    Object.keys(columnkeyMap).map(function (key) {
                        if (key === "selosSegurancaSelagemViatura") {
                            for (let index = 0; index < _row.selosSegurancaSelagemViatura.length; index++) {
                                var selo = _row.selosSegurancaSelagemViatura[index].selo
                                if(index == 0){
                                    var sequencia = selo
                                }else{
                                    var sequencia = sequencia + "," + selo 
                                }
                                _row[columnkeyMap[key]] = sequencia
                            }
                        } else if (key === "etiquetasSegurancaViatura") {
                            for (let index = 0; index < _row.etiquetasSegurancaViatura.length; index++) {
                                var selo = _row.etiquetasSegurancaViatura[index].etiqueta
                                if(index == 0){
                                    var sequencia = selo
                                }else{
                                    var sequencia = sequencia + "," + selo 
                                }
                                _row[columnkeyMap[key]] = sequencia
                            }
                        }else
                            _row[columnkeyMap[key]] = _row[key]
                    })
                    if (_row.document_type === "Invoice") {
                        _row.document_type = "Movements"
                    } else if (_row.document_type === "Credit") {
                        _row.document_type = "Crédito"
                    }
                });
                console.log("Akash","1",res);
                idAutoe = res
                this.setState({
                    data: res,
                    filterData: res,
                    totalcount: res.length,
                    findnonDocumentedRow
                }, () =>{
                    console.log("Akash","2");
                    this.createTabel()
                });
            }else{
                this.setState({
                    data: res,
                    filterData: res,
                    totalcount:0
                },()=>{
                    this.createTabel()
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter }
        console.log("Request" ,Request)
        
        console.log("STATE" , Request.Filters.entityIdFilter)
        console.log("Akash","3" , Request.Filters.entityIdFilter);
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = {...this.state.linkData.columnkeyMap}
            if (this.state.findnonDocumentedRow === 0) {
                delete columnkeyMap["Check"]
            }
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            console.log("columnlist",columnlist);
            console.log("filterData",this.state.filterData);
            
            let telkikTable = <TlkTable
                date={new Date()}
                generateDocument={this.state.findnonDocumentedRow === 0 ? null : this.state.linkData.generateDocument}
                noDownloadButton={this.state.linkData.noDownloadButton}
                DocumentGERFIP={this.state.linkData.DocumentGERFIP}
                actionColumnName={this.state.linkData.actionColumnName}
                groupfield={this.state.linkData.groupfield}
                modulename={this.state.linkData.modulename || "CriarFatura"}
                notAction={this.state.linkData.notAction}
                tlkState={this.state.tlkState}
                notGroup={true}
                deleteFunc={(id) => this.deleteFunc(id)}
                tableFilters={(filter) => this.tableFilters(filter)}
                list={this.state.filterData}
                actionbuttons={actionbuttons}
                columnlist={columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)} />
            this.setState({
                telkikTable: telkikTable
            })
        }
    }

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        console.log("tlfilter",tlfilter);
        try{
            if(JSON.stringify(tlfilter) !== JSON.stringify(this.state.tlkState)){
                let customfilters = this.getAllFilter();
                let columnkeyMap = this.state.linkData.columnkeyMap;
                let tlkState = { ...tlfilter };
                let data = this.makeTlkFilters(tlfilter, columnkeyMap, customfilters);
                let linkData = { ...this.state.linkData };
            
                // linkData.Filters = data.Filters
                this.setState({
                    tlkState,
                    linkData
                }, () => this.getListData());
            }
        }catch(error){
            this.setState({error : error})
        }
        // return data;
    }

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (tlkfilter.filter && tlkfilter.filter.filters && tlkfilter.filter.filters.length > 0) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value=_srow.value ?_srow.value : ""
                        checkamount =  _srow.value.split(" ")
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value) ? Number(_srow.value) : _srow.value;
                        tkkeyvalues.push(_srow.value)
                    })
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            })
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip ? (tlkfilter.skip / tlkfilter.take + 1) : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC = (tlkfilter.sort[0].dir === "asc") ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        console.log("action perform")
        if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row)
        } else {
            let popUpForm = null;
        }
    }

    static removeAllRows(){
        if(ThisSetState){
            ThisSetState.refreshDS(true);
        }
    };

    /*  Para renderizar o conteúdo html da página   */
    static CommandCell = props => <MyCommandCell {...props} edit={ThisSetState.enterEdit} remove={ThisSetState.remove} add={ThisSetState.add} discard={ThisSetState.discard} update={ThisSetState.update} cancel={ThisSetState.cancel} editField={editField} />; // modify the data in the store, db etc

    remove = dataItem => {
        const data = deleteItem(dataItem);
        this.setState({
          data : data
        });
    };

    add = dataItem => {
        var arrayElementos =  []  
        arrayElementos.length = 0
        var inputsGrid = $(".k-grid-table tbody td input#numberboxcell");
        var selectGrid = $("span.k-input");
        for (let index = 0; index < inputsGrid.length; index++) {
            var elementos = inputsGrid[index].value;
            var elementoInput = inputsGrid[index];
            if($(elementoInput).prop("disabled") == false){
                if(elementos == ""){
                    arrayElementos.push(elementos)
                }
            }
        }
        for (let i = 0; i < selectGrid.length; i++) {
            var elementos = selectGrid[i].innerHTML
            if(elementos == ""){
                arrayElementos.push(elementos)
            }
        }
        var multipleselect = $(".k-grid-table tbody td .ant-select-show-search")
        for (let index = 0; index < multipleselect.length; index++) {
            var elementos = multipleselect[index].children
            if(elementos.length == 2 ){
                
            }else{
                arrayElementos.push("")
            }
            
        }
        
        // if(arrayElementos.length > 0){
        //     Swal.fire({
        //         title: 'Têm de preencher todos os campos na grid',
        //         icon: 'error',
        //         confirmButtonText: 'Ok'
        //     })
        // }else{
            dataItem.inEdit = true;
            const data = insertItem(dataItem);
            arrayDataOnEdit = [];
            arrayDataOnEdit.push(dataItem);
            this.setState({
                data: data
            });
       // }
        
    }

    update = dataItem => {
      dataItem.inEdit = false;
      const data = updateItem(dataItem);
      this.setState({
        data
      });
    }; // Local state operations
  
    discard = () => {
      const data = [...this.state.data];
      data.splice(0, 1);
      this.setState({
        data
      });
      arrayData.splice(0,1);
    };

    cancel = dataItem => {
        this.setState({data:  this.state.data.map(item => item === dataItem ? { ...item,inEdit: false } : item)}); 
    };
    enterEdit = dataItem => {
        console.log(this.state.data)
        if(this.state.data.length > 0){
            this.setState({
                data: this.state.data.map(item => item === dataItem ? { ...item,inEdit: true , NewItem :false} : item)
              });
        }else{
            this.setState({
                data: arrayData.map(item => item.ProductID === dataItem.ProductID ? { ...item,inEdit: true ,NewItem :false} : item)
              });
        }
          
    };

    itemChange = event => {
        
        if(event.field == "N_Vasilha"){

            $('.capacidadeaferida').text(event.value.CapacidadeCalculada)
            $('.capacidadecomunicada').val(event.value.CapacidadeComunicada)

        }

        if(event.field == "Tipo_Vasilha"){
            DropDownCellNVasilha.ChangeValueById(event.value.value);

            $('.capacidadeaferida').text('')
            $('.capacidadecomunicada').val('')

        }

        if(event.field == "Reg_Depos"){

            DropDownCellFiscalizacao3.disablEnableDroDown(!event.value);
    
        }
       
        const data = this.state.data.map(item => event.dataItem != null ?  item.ProductID === event.dataItem.ProductID ? { ...item,
            [event.field || '']: event.value
        } : item : item);
       
        this.setState({
            data
        });

    };
    
    

    addNew = () => {

        if(!$('.botaoAdicionarNovoEnable').hasClass('disabled')){

            if($('#tabelaNovaAdicionar .k-grid-save-command').length == 0){

                const newDataItem = {
                            inEdit: true,
                            Discontinued: false,
                            NewItem :true,
                };
                if(arrayData.length > 0){
                    this.setState({
                        data: [newDataItem, ...arrayData]
                    });
                }else{
                    this.setState({
                        data: [newDataItem, ...this.state.data]
                    });
                }
                

            }
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Não pode adicionar quando existe linhas em edição',
            }) 
        }

    };

    refreshDS = (remove) =>{

        this.setState({
            data: []
        })

        arrayData = [];

        deleteAll();
    }

    SetColumnState = () =>{
        this.setState({
            Columns : this.props.columnList
          });
    }

    // static updateColumns = () =>{

    //     ThisSetState.setState({Columns : this.props.columnList});
    //     ThisSetState.refreshDS(true);

    // }

    render() {

        if(this.state.error){
            throw this.state.error;
        }        
       indexEntrada =+ 1

        if(this.state.data != undefined){
            if(this.state.data.length > 0){
                
                arrayData = this.state.data
                
            }
        }
        return (
            // DesselagemQuery == "true" ? 
            // this.state.telkikTable  
            // : 
            <div className="custom-k-grid table-section">
                <div className="table-responsive" id='tabelaNovaAdicionar'>

                    <Grid style={{height: "420px"}} data={arrayData.length > 0 ? arrayData : this.state.data } onItemChange={this.itemChange} editField={editField}>
                        <GridToolbar>
                            <button title="Adicionar" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary botaoAdicionarNovoEnable disabled" onClick={this.addNew}>
                                + Adicionar
                            </button>
                        </GridToolbar>
                        {this.props.columnList}
                    </Grid>
                </div>
            </div>

        )
    }
}

export const changeValueSelect = (e) => {

    SelectCellEtiquetas.changeValueFromSelect(e);
    SelectCellSelos.changeValueFromSelect(e);
    SelectCellEtiquetasSelagem.changeValueFromSelect(e);
    SelectCellSelosSelagem.changeValueFromSelect(e);
    SelectCellSelosGarantia.changeValueFromSelect(e);

}

export const changeColumnsFiscalizacaoGrid = (auto, typeAuto) => {

};

export default {ClassGrid3, DropDownCellFiscalizacao3, DropDownCellMotivoDispensa3};